<template>
  <div class="savedDesignItem">
    <div class="savedDesignWrapper">
      <div class="discontinued" v-if="!design.product.isPublished">
        Discontinued
      </div>
      <router-link
        tag="div"
        class="tile"
        :to="{ name: 'designPreview', params: { id: design._id } }"
      >
        <div class="image">
          <div
            v-if="design.thumbnailSmallCenterPath"
            class="imageContainer"
            :style="{
              'background-image': `url('${design.thumbnailSmallCenterPath}')`
            }"
          >
            &nbsp;
          </div>
          <div v-else>
            No image
          </div>
        </div>
        <div class="info">
          <div class="firstLine">
            <div class="styleName">
              {{ design.style }}
            </div>
            <div class="date">
              {{ new Date(design.modifiedAt) | dateFormat('MM/DD/YY') }}
            </div>
          </div>
          <div class="designName">
            {{ design.name }}
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class SavedDesign extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  design
}
</script>

<style lang="scss" scoped>
.savedDesignItem {
  background: #ffffff;
  border: 1px solid #696969;
  margin: 8.5px;
  min-width: 330px;
  position: relative;

  &:hover {
    background: #f5f6fe;
    border: none;
    .savedDesignWrapper {
      box-shadow: -1px 0 22px 0 rgba(0, 0, 0, 0.15);
    }
    .actions {
      opacity: 1;
    }
  }
}

#noData {
  text-align: center;
}
.discontinued {
  background-color: #fff1aa;
  padding: 3px 4px 1px 9px;
  position: absolute;
  left: -1px;
  top: 14px;

  font-size: rem(12px);
  font-weight: bold;
  color: #202020;
  letter-spacing: 0.35px;
  line-height: 17px;
  text-align: center;
  text-transform: uppercase;
}
.tile {
  cursor: pointer;
  display: flex;
  .image {
    align-items: center;
    background-color: white;
    display: flex;
    height: 146px;
    justify-content: center;
    padding: 10px;
    width: 101px;
    .imageContainer {
      background-size: contain;
      background-position: center center;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
    }
  }
  .info {
    flex: auto;
    font-size: rem(14px);
    padding: 13px 16px 22px 15px;
    .firstLine {
      display: flex;
      justify-content: space-between;
      letter-spacing: 0.41px;
      line-height: 19px;
      margin-bottom: 7px;
      text-transform: uppercase;
      .styleName {
        color: #202020;
        font-weight: bold;
        max-width: 130px;
      }
      .date {
        color: #000000;
      }
    }
    .designName {
      color: #202020;
      font-size: rem(13px);
      font-weight: 500;
      letter-spacing: 0.38px;
      line-height: 17px;
      text-transform: uppercase;
    }
  }
}
.savedDesignItem {
  $colorHover: blue;
  &:hover {
    color: $colorHover;
    .firstLine {
      .styleName,
      .date {
        color: $colorHover;
      }
    }
    .designName {
      color: $colorHover;
    }
  }
}
</style>
